import Component from '../core/Component';

export default class MenuOpener extends Component {

    constructor(element) {
        super(element);
    }

    prepare() {
        //let nav = document.querySelector('[data-component="Nav"]');
        //let menu = Component.getFromElement(nav);

        this.element.addEventListener('click', event => {
            if (document.documentElement.classList.contains('menu-is-opened')) {
                //menu.close();
                this.close();
            } else {
                //menu.open();
                this.open();
            }
        });

        document.addEventListener('keydown', event => {
            if (event.keyCode == 27 && document.documentElement.classList.contains('menu-is-opened')) {
                this.close();
            }
        });

        document.addEventListener('swup:clickLink', ::this.close);
    }

    open() {
        document.documentElement.classList.add(`menu-anim-${Math.round(Math.random() * 2 + 1)}`);
        document.documentElement.classList.add('menu-is-opened');
        //setTimeout(()=> {document.documentElement.classList.add('menu-is-fully-opened');}, 1400)
    }

    close() {
        document.documentElement.classList.add('menu-is-closing');
        //document.documentElement.classList.remove('menu-is-fully-opened');
        document.documentElement.classList.remove('menu-is-opened');
        document.documentElement.classList.remove('menu-anim-1');
        document.documentElement.classList.remove('menu-anim-2');
        document.documentElement.classList.remove('menu-anim-3');
        setTimeout(() => {document.documentElement.classList.remove('menu-is-closing');}, 1000)
    }
}


// WEBPACK FOOTER //
// ./components/MenuOpener.js